<template>
  <div class="app-wrap">
    <div v-if="isLoading" class="se-pre-con"></div>
    <img alt="Gomobile logo" src="@/assets/logonew.svg" class="company-logo" />
    <form v-if="!showThanks" action="#">
      <div class="paragraph-wrap">
        <h1 class="text-bold text-primary no-top-margin text-center">
          {{ $t("main.header") }}
        </h1>
        <h2 class="text-bold text-primary no-top-margin">
          {{ $t("main.header1") }}
        </h2>
        <p class="paragraph">
          <i18next :translation="$t('main.text1')">
            <!-- <template #shortFormLink>
              <RouterLink
                class="orange-text"
                :to="{
                  path: '/short-form',
                  query: $route.query,
                }"
                >{{ $t("main.shortFormHere") }}</RouterLink
              >
            </template> -->
          </i18next>
        </p>
        <p class="paragraph">{{ $t("main.text2") }}</p>
        <h2 class="text-bold text-primary">{{ $t("name.header") }}</h2>
        <TextareaAutosize
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.name"
          type="text"
          :min-height="10"
          :max-height="350"
          :placeholder="$t('name.placeholder')"
        />
        <div class="">
          <h2
            class="text-bold "
            :class="{ alertLine: isAlertCommand }"
            id="command-required"
          >
            <span class="custom-asterisk">*</span>
            <span class="text-primary">
            Как ты оцениваешь работу команды проекта в данном квартале?</span>
          </h2>
          <ThePointsbar
            @change="feedbackData.fullRating = $event"
            :size="10"
            code="commandRating"
            :full-name="true"
          />
        </div>
        <!-- <h2 class="text-bold text-primary">
          {{ $t("fullRating.header") }}
        </h2> -->
        <!--  <TheRadiobox
          v-for="(value, index) in $t('fullRating.grades', {
            returnObjects: true,
          })"
          :key="index"
          @radioChange="addHowFound"
          :text="value"
          name="howFound"
        />
        <TextareaAutosize
          v-if="feedbackData.fullRating.length > 0"
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="otherHowFound"
          :min-height="10"
          :max-height="350"
          name="comment"
          :placeholder="$t('fullRating.comment')"
        /> -->

        <h2 class="text-bold text-primary" :class="{ alertLine: isAlert2 }" id="must-answer-work">{{ $t("units.header") }}</h2>
        <p class="paragraph">
          {{ $t("units.text") }}
        </p>
        <!-- <h2
          :class="{ alertLine: isAlert2 }"
          class="text-bold"
          
        >
          <span class="text-primary custom-asterisk"></span>
          <span>{{ $t("units.isNecessary.text") }}</span>
        </h2> -->
        <TheEvaluation
          v-for="(unit, unitName, index) in $t('units.values', {
            returnObjects: true,
          })"
          :key="index"
          @change="feedbackData.depts[unitName] = $event"
          :main-text="unit.header"
          :secondary-text="unit.text"
          :hint="$t('units.hint')"
          :has-error="isAlert2"
        />
      </div>
      <div class="paragraph-wrap">
        <h2
          class="text-bold"
          :class="{ alertLine: isAlertKpi }"
        >
          <span class=" custom-asterisk">*</span>
          <span class="text-primary">
          Насколько вы удовлетворены динамикой выполнения KPI?</span>
        </h2>
        <ThePointsbar
          @change="feedbackData.kpiRating = $event"
          :size="10"
          code="kpi"
          :full-name="true"
        />

        <h2
          :class="{ alertLine: isAlert }"
          class="top-wrap text-bold"
          id="must-answer"
        >
          <span class="custom-asterisk">*</span>
         <span class="text-primary"> {{ $t("recommendation.header") }}</span>
          <span v-if="isAlert" class="text-primary custom-asterisk"
            >({{ $t("isNecessary.text") }})</span
          >
        </h2>
        <ThePointsbar
          @change="feedbackData.recomendation = $event"
          :size="10"
          code="recomendation"
          @alert="isAlert3 = $event"
          :alertLine="isAlert"
          :full-name="true"
        />

        <h2 class="top-wrap text-bold text-primary">
          {{ $t("improve.header") }}
        </h2>
        <TextareaAutosize
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.feedback"
          :min-height="10"
          :max-height="350"
          name="become_better"
          :placeholder="$t('improve.placeholder')"
        />
      </div>
      <button type="button" class="submit-button" @click="sendFeedback">
        <span>{{ $t("sendBtn") }}</span
        ><img src="@/assets/message.svg" />
      </button>
    </form>
    <div v-else class="thanks-text">
      <h1>{{ $t("thanks.header") }}</h1>
      <p>{{ $t("thanks.text1") }}</p>
      <p v-if="$i18next.language === 'ru'">
        {{ $t("thanks.text2") }} (<a
          class="enable-select"
          target="_blank"
          :href="`https://${$t('thanks.email1')}`"
          >{{ $t("thanks.email3") }}</a
        >) {{ $t("thanks.text3") }} (<a
          class="enable-select"
          :href="`mailto: ${$t('thanks.email2')}`"
          >{{ $t("thanks.email2") }}</a
        >).
      </p>
      <p v-else>
        {{ $t("thanks.text2") }}
        <a class="enable-select" :href="`mailto: ${$t('thanks.email1')}`">{{
          $t("thanks.email1")
        }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import TheEvaluation from "@/components/TheEvaluation.vue";
import ThePointsbar from "@/components/ThePointsbar";
// import TheCheckbox from "@/components/TheCheckbox";
import TextareaAutosize from "@/components/TextareaAutosize.vue";
import API from "@/api";
import i18next from "i18next";

export default {
  name: "App",
  components: {
    // TheCheckbox,
    TheEvaluation,
    ThePointsbar,
    TextareaAutosize,
  },
  data: function () {
    return {
      otherHowFound: "",
      showThanks: false,
      isLoading: false,
      isAlert: false,
      isAlert2: false,
      isAlert3: false,
      isAlertKpi: false,
      isAlertCommand: false,
      feedbackData: {
        // table: "simple",
        table: process.env.VUE_APP_LANGUAGE === "en" ? "ww" : "simple",
        version: "v2",
        name: "",
        isShort: false,
        fullRating: "",
        depts: {
          clientService: {
            rating: "",
            feedback: "",
            notInteracted: false,
          },
          mediaBuying: {
            rating: "",
            feedback: "",
            notInteracted: false,
          },
          aso: {
            rating: "",
            feedback: "",
            notInteracted: false,
          },
          design: {
            rating: "",
            feedback: "",
            notInteracted: false,
          },
          finance: {
            rating: "",
            feedback: "",
            notInteracted: false,
          },
          strategy: {
            rating: "",
            feedback: "",
            notInteracted: false,
          },
          analytics: {
            rating: "",
            feedback: "",
            notInteracted: false,
          },
          business: {
            rating: "",
            feedback: "",
            notInteracted: false,
          },
        },
        kpiRating: "",
        recomendation: "",
        personalFeedback: "",
        commandRating: "",
        howFound: [],
        feedback: "",
        paramName: "",
      },
    };
  },

  methods: {
    sendFeedback: async function () {
      // сброс предыдущих подсветок
      this.isAlert = false;
      this.isAlert2 = false;
      this.isAlert3 = false;
      this.isAlertKpi = false;
      this.isAlertCommand = false;

      if (
        this.feedbackData.fullRating.length > 0 &&
        this.otherHowFound.length > 0
      ) {
        this.feedbackData.fullRating =
          this.feedbackData.fullRating + " Коментарий: " + this.otherHowFound;
      }
      if (!this.feedbackData.fullRating) {
        const elCommand = document.getElementById("command-required");
        if (elCommand) {
          elCommand.scrollIntoView({ block: "center", behavior: "smooth" });
        }
        this.isAlertCommand = true;
        return;
      }

      if (!this.feedbackData.kpiRating) {
        const elKpi = document.getElementById("kpi-required");
        if (elKpi) {
          elKpi.scrollIntoView({ block: "center", behavior: "smooth" });
        }
        this.isAlertKpi = true;
        return;
      }

      if (this.feedbackData.recomendation.length === 0) {
        const elRec = document.getElementById("must-answer");
        if (elRec) {
          elRec.scrollIntoView({ block: "center", behavior: "smooth" });
        }
        this.isAlert = true;
        return;
      }
      // if (this.feedbackData.recomendation.length === 0) {
      //     document.getElementById("must-answer-recomend").scrollIntoView({ block: "center", behavior: "smooth" });
      //     this.isAlert3 = true;
      //     return;
      // }
      const units = this.$t("units.values", { returnObjects: true });
      for (let unitName in units) {
        const dept = this.feedbackData.depts[unitName];
        // обязательно: либо есть оценка, либо стоит галочка "не взаимодействовал(а)"
        if (!dept || (!dept.notInteracted && !dept.rating)) {
          const elWork = document.getElementById("must-answer-work");
          if (elWork) {
            elWork.scrollIntoView({ block: "center", behavior: "smooth" });
          }
          this.isAlert2 = true;
          return;
        }
      }

      this.isLoading = true;
      const that = this;
      try {
        if (this.feedbackData.paramName === "") {
          this.feedbackData.paramName =
            "Клиент стер уникальный параметр ссылки";
        }
        const payload = JSON.parse(JSON.stringify(this.feedbackData));
        for (const key in payload.depts) {
          delete payload.depts[key].notInteracted;
        }
        const api = new API();
        await api.push(payload).then(function () {
          that.isLoading = false;
        });
        that.isLoading = false;
      } catch (e) {
        console.error(e);
      }
      this.showThanks = true;
    },
    getData: async function () {
      try {
        const requestOptions = {
          method: "GET",
          redirect: "follow",
        };

        fetch(
          "https://script.google.com/macros/s/AKfycbwbLK1711GhF3e9QZX8kHoLqBKaHQdUmhTAxHmw9oVZPdp3EHKvSawR4xC4MuH3XSD1Rw/exec",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            const locat = location;
            let index = 0;
            let end = 0;
            for (let i = 0; i < result.length; i++) {
              if ("GoMobile" === result[i][0]) {
                index = i;
              }
              if ("GoMobileWW" === result[i][0]) {
                end = i;
              }
            }
            result = result.slice(index + 1, end);
            for (let i = 0; i < result.length; i++) {
              let param = result[i][1].slice(result[i][1].indexOf("?"));
              if (param == locat.search) {
                this.feedbackData.paramName = result[i][0];
                // console.log(this.feedbackData.paramName);
                return;
              }
            }
          })
          .catch((error) => console.error(error));
      } catch (err) {
        console.log(err);
      }
    },
    addHowFound(val) {
      this.feedbackData.fullRating = val.text;
    },
  },
  computed: {
    screenWidth() {
      return window.innerWidth;
    },
    isActiveOther() {
      if (
        this.feedbackData.howFound.includes(
          i18next.t("fullRating.values", { returnObjects: true }).at(-1),
        )
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
@media only screen and (max-width: 670px) {
  .paragraph-wrap {
    padding-left: 14px;
    padding-right: 14px;
  }

  .text-bold {
    line-height: 1.3;
  }

  .custom-asterisk {
    margin-right: 4px;
  }

  .submit-button {
    width: calc(100% - 28px);
    margin-left: 14px;
    margin-right: 14px;
  }
}
</style>
